import React from 'react';
import HeroSection from './landingPage/HeroSection';
import EventsGrid from './landingPage/EventsGrid';
import NewsletterSection from './landingPage/SupportSection';
import EventsTopBar from './landingPage/EventsTopBar';
import EventsFooter from './landingPage/EventsFooter';
import WaveSeparator from './landingPage/WaveSeparator';

const EventLayout = ({ children }) => {
    return (
        <div className='min-h-screen flex flex-col'>
            <EventsTopBar />
            <main className='flex-grow relative'>
                {children}
            </main>
            <EventsFooter />
        </div>
    );
};

export default EventLayout;
